/**
 * Onboarding is an admin task: only members whose org role can write
 * `organizations.settings` can complete the wizard. Gating the `/onboarding`
 * redirect on a lesser role funnels a member into a wizard whose completion
 * write silently no-ops, trapping them in a loop.
 *
 * This is the org-membership half of the `organizations` UPDATE policy and
 * matches the ROLE SET of `useCanManageOrgSettings`; membership status is the
 * caller's responsibility (that hook additionally requires an active
 * membership, this predicate is role-only by design). The policy additionally
 * allows platform admins via `is_admin(auth.uid())`; that branch is enforced
 * server-side in `mark_org_onboarding_complete`, not on the client.
 */
const ONBOARDING_CAPABLE_ROLES: ReadonlySet<string> = new Set([
  'org_admin',
  'org_manager',
  'party_director',
]);

/**
 * Whether an organization role is allowed to complete onboarding for its org.
 * Accepts the raw role string (org membership role or invitation role, which
 * resolves to the same `organization_role` value at membership-creation time).
 */
export function canRoleCompleteOnboarding(role: string | null | undefined): boolean {
  return role != null && ONBOARDING_CAPABLE_ROLES.has(role);
}
